import React from 'react';
import { POPULAR_ROUTES } from '../data/visa-data';

interface PopularRoutesProps {
  onSelect: (from: string, to: string) => void;
}

const PopularRoutes: React.FC<PopularRoutesProps> = ({ onSelect }) => {
  return (
    <div className="mt-5">
      <p className="text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">Popular routes</p>
      <div className="flex flex-wrap gap-2">
        {POPULAR_ROUTES.map((route, idx) => (
          <button
            key={idx}
            type="button"
            onClick={() => onSelect(route.fromCode, route.toCode)}
            className="inline-flex items-center gap-1.5 px-3 py-1.5 bg-white border border-slate-200 rounded-full text-xs font-medium text-slate-600 hover:border-blue-300 hover:text-blue-600 hover:bg-blue-50 transition-all"
          >
            {route.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default PopularRoutes;
